import type { ReportGuideDetails, ReportGuideId } from '../../../shared/domain/guides/types.no-deps'
import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/guides/reportGuideDetails/bulk' }

// Temporary override for the `data` property inside `ReportGuideDetails`
// so that schema validation doesn't fail. This is due to inconsistencies between
// the declared model and the actual (de)serialized object that is present in the database.
// TODO: fix this (ZAP-2545)
interface EndpointResult extends ReportGuideDetails {
    data: any
}

type Params = never
type Body = { ids: ReportGuideId[] }
type Query = { lastSyncTime?: Date }
type Output = { reportGuideDetails: EndpointResult[] }

export type GetReportGuideDetailsBulkEndpoint = Endpoint<Params, Body, Query, Output>

export const getReportGuideDetailsBulkRequest = (
    request: Request,
    args: RequestArgs<GetReportGuideDetailsBulkEndpoint>
) => request<GetReportGuideDetailsBulkEndpoint>(route, args)
